export default __webpack_public_path__ + "media/images/main/formats-07d0e4d2d6aa227c79d6befb1b3152c7.png";